(function () {
  var MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function boolAttr(value) {
    return value === 'true';
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function ordinal(n) {
    var suffixes = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }

  function getTimezoneCity() {
    try {
      var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (!timezone || timezone.indexOf('/') === -1) return '';
      return timezone.split('/').pop().replace(/_/g, ' ');
    } catch (e) {
      return '';
    }
  }

  function buildLocationText(data, type) {
    var city = data.city || '';
    var region = data.region || '';
    var country = data.country || '';

    if (type === 'region') return region;
    if (type === 'country') return country;
    if (type === 'city_region') return city && region ? city + ', ' + region : city || region;
    if (type === 'city_country') return city && country ? city + ', ' + country : city || country;
    return city;
  }

  function applyGeo(spans, geo) {
    spans.forEach(function (span) {
      var type = span.dataset.locationType || 'city';
      var fallback = span.dataset.locationFallback || 'your area';
      var text = buildLocationText(geo, type);
      span.textContent = text || fallback;
    });
  }

  function initLocation(block) {
    var spans = toArray(block.querySelectorAll('.text-block__location'));
    if (!spans.length) return;

    var needsInit = false;
    spans.forEach(function (span) {
      if (span.dataset.textLocationInitialized !== 'true') needsInit = true;
      span.dataset.textLocationInitialized = 'true';
    });
    if (!needsInit) return;

    var cacheKey = 'sugar_geo_v4';
    var cached = null;
    try { cached = sessionStorage.getItem(cacheKey); } catch (e) {}

    if (cached) {
      try {
        applyGeo(spans, JSON.parse(cached));
        return;
      } catch (e) {}
    }

    var firstSpan = spans[0];

    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.success === false) throw new Error();
        return { city: data.city || '', region: data.region || '', country: data.country || '' };
      })
      .catch(function () {
        return {
          city: getTimezoneCity(),
          region: '',
          country: (firstSpan && (firstSpan.dataset.locationCountry || firstSpan.dataset.locationCountryCode)) || '',
        };
      })
      .then(function (geo) {
        try { sessionStorage.setItem(cacheKey, JSON.stringify(geo)); } catch (e) {}
        applyGeo(spans, geo);
      });
  }

  function initDates(block) {
    var spans = toArray(block.querySelectorAll('.text-block__date'));
    if (!spans.length) return;

    spans.forEach(function (span) {
      if (span.dataset.textDateInitialized === 'true') return;
      span.dataset.textDateInitialized = 'true';

      var offset = parseInt(span.dataset.dateOffset, 10) || 0;
      var direction = span.dataset.dateDirection === 'future' ? 1 : -1;
      var format = span.dataset.dateFormat || 'short';
      var date = new Date();
      if (direction === 1) {
        // Datas futuras (ex.: entrega) contam só dias úteis: salta sábados e domingos
        var left = offset;
        while (left > 0) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && date.getDay() !== 6) left--; }
      } else {
        date.setDate(date.getDate() + offset * direction);
      }

      var d = date.getDate();
      var m = date.getMonth();
      var y = date.getFullYear();
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var text;

      switch (format) {
        case 'long':
          text = MONTH_FULL[m] + ' ' + d + ', ' + y; break;
        case 'day_name':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_SHORT[m] + ' ' + d; break;
        case 'day_name_long':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_FULL[m] + ' ' + d; break;
        case 'numeric':
          text = pad(m + 1) + '/' + pad(d) + '/' + y; break;
        case 'day_month':
          text = d + ' ' + MONTH_SHORT[m] + ' ' + y; break;
        case 'day_month_long':
          text = d + ' ' + MONTH_FULL[m] + ' ' + y; break;
        case 'month_day':
          text = MONTH_FULL[m] + ' ' + d; break;
        case 'long_ordinal':
          text = MONTH_FULL[m] + ' ' + ordinal(d) + ', ' + y; break;
        case 'day_name_long_ordinal':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_FULL[m] + ' ' + ordinal(d); break;
        case 'day_month_long_ordinal':
          text = ordinal(d) + ' ' + MONTH_FULL[m] + ' ' + y; break;
        case 'month_day_ordinal':
          text = MONTH_FULL[m] + ' ' + ordinal(d); break;
        default:
          text = MONTH_SHORT[m] + ' ' + d + ', ' + y;
      }

      // Loja em português: datas em português (ex.: terça-feira, 13 de outubro)
      var lang = (document.documentElement.lang || '').toLowerCase();
      if (lang.indexOf('pt') === 0 && window.Intl) {
        var PT = {
          long: { day: 'numeric', month: 'long', year: 'numeric' },
          day_name: { weekday: 'long', day: 'numeric', month: 'short' },
          day_name_long: { weekday: 'long', day: 'numeric', month: 'long' },
          numeric: { day: '2-digit', month: '2-digit', year: 'numeric' },
          day_month: { day: 'numeric', month: 'short', year: 'numeric' },
          day_month_long: { day: 'numeric', month: 'long', year: 'numeric' },
          month_day: { day: 'numeric', month: 'long' },
          long_ordinal: { day: 'numeric', month: 'long', year: 'numeric' },
          day_name_long_ordinal: { weekday: 'long', day: 'numeric', month: 'long' },
          day_month_long_ordinal: { day: 'numeric', month: 'long', year: 'numeric' },
          month_day_ordinal: { day: 'numeric', month: 'long' }
        };
        try { text = new Intl.DateTimeFormat('pt-PT', PT[format] || { day: 'numeric', month: 'short', year: 'numeric' }).format(date).replace(/\.$/, ''); } catch (e) {}
      }

      span.textContent = text;
    });
  }

  function initCountdown(block) {
    var timer = block.querySelector('[data-countdown-timer]');
    if (!timer || timer.dataset.textCountdownInitialized === 'true') return;
    timer.dataset.textCountdownInitialized = 'true';

    var hoursEl = timer.querySelector('[data-countdown-hours]');
    var minutesEl = timer.querySelector('[data-countdown-minutes]');
    var secondsEl = timer.querySelector('[data-countdown-seconds]');

    var initialHours = parseInt(timer.dataset.initialHours, 10) || 0;
    var initialMinutes = parseInt(timer.dataset.initialMinutes, 10) || 0;
    var initialSeconds = parseInt(timer.dataset.initialSeconds, 10) || 0;
    var shouldRestart = timer.dataset.restart === 'restart';

    var totalSeconds = initialHours * 3600 + initialMinutes * 60 + initialSeconds;
    var originalTotal = totalSeconds;

    function updateDisplay() {
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    function tick() {
      if (totalSeconds > 0) {
        totalSeconds -= 1;
      } else if (shouldRestart) {
        totalSeconds = originalTotal;
      }
      updateDisplay();
    }

    updateDisplay();
    setInterval(tick, 1000);
  }

  function findBodyModalByClass(className) {
    var children = document.body ? document.body.children : [];
    var i;
    for (i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains(className)) {
        return children[i];
      }
    }
    return null;
  }

  function getParsedInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function resolveSectionTargetId(config) {
    var sectionId = (config.sectionId || '').replace(/^#/, '');
    if (sectionId) return sectionId;
    if (config.href && config.href.charAt(0) === '#') return config.href.slice(1);
    return '';
  }

  function scrollToSectionTarget(config) {
    var targetId = resolveSectionTargetId(config);
    if (!targetId) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    var scrollOffset = getParsedInt(config.scrollOffset, 20);
    var headerHeight = getParsedInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0',
      0
    );
    var targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - scrollOffset;

    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  }

  function navigateToPage(config) {
    var href = config.href || '';
    if (!href || href === '#') return;

    if (config.newTab) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }

    window.location.href = href;
  }

  function initLinkActions(block) {
    var contentArea = block.querySelector('.text-block__content');
    if (!contentArea) return;

    var configs = [
      {
        enabled: boolAttr(block.dataset.textLinkStrongEnabled),
        selector: 'strong',
        mode: block.dataset.textLinkStrongMode || 'page',
        href: block.dataset.textLinkStrongHref || '',
        newTab: boolAttr(block.dataset.textLinkStrongNewTab),
        sectionId: block.dataset.textLinkStrongSectionId || '',
        scrollOffset: block.dataset.textLinkStrongScrollOffset,
      },
      {
        enabled: boolAttr(block.dataset.textLinkEmEnabled),
        selector: 'em',
        mode: block.dataset.textLinkEmMode || 'page',
        href: block.dataset.textLinkEmHref || '',
        newTab: boolAttr(block.dataset.textLinkEmNewTab),
        sectionId: block.dataset.textLinkEmSectionId || '',
        scrollOffset: block.dataset.textLinkEmScrollOffset,
      },
      {
        enabled: boolAttr(block.dataset.textLinkUnderlineEnabled),
        selector: 'u, span[style*="underline"]',
        mode: block.dataset.textLinkUnderlineMode || 'page',
        href: block.dataset.textLinkUnderlineHref || '',
        newTab: boolAttr(block.dataset.textLinkUnderlineNewTab),
        sectionId: block.dataset.textLinkUnderlineSectionId || '',
        scrollOffset: block.dataset.textLinkUnderlineScrollOffset,
      },
    ];

    configs.forEach(function (config) {
      if (!config.enabled) return;

      toArray(contentArea.querySelectorAll(config.selector)).forEach(function (trigger) {
        if (trigger.dataset.textLinkInitialized === 'true') return;
        if (trigger.closest('a')) return;

        trigger.dataset.textLinkInitialized = 'true';

        if (!trigger.hasAttribute('role')) trigger.setAttribute('role', 'link');
        if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
        if (!trigger.hasAttribute('aria-label')) {
          var label = (trigger.textContent || '').trim();
          if (label) trigger.setAttribute('aria-label', label);
        }

        function activate(event) {
          event.preventDefault();
          event.stopPropagation();

          if (config.mode === 'section') {
            scrollToSectionTarget(config);
            return;
          }

          navigateToPage(config);
        }

        trigger.addEventListener('click', activate);
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            activate(event);
          }
        });
      });
    });
  }

  function initPopup(block, blockId) {
    var modalId = block.dataset.textPopupModalId || blockId;
    var uniqueClass = 'text-popup-modal--' + modalId;
    var sectionRoot = block.closest('.shopify-section') || document;
    var modal = sectionRoot.querySelector('.' + uniqueClass) || document.querySelector('.' + uniqueClass);
    var contentArea = block.querySelector('.text-block__content');
    if (!modal || !contentArea) return;

    var existingBodyModal = findBodyModalByClass(uniqueClass);
    if (existingBodyModal && existingBodyModal !== modal) {
      if (existingBodyModal.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
      existingBodyModal.remove();
    }

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    if (modal.dataset.textPopupInitialized === 'true') return;
    modal.dataset.textPopupInitialized = 'true';

    var closeOnOutsideClick = boolAttr(block.dataset.textPopupCloseOnOutside);
    var testMode = block.dataset.textPopupTestMode || modal.dataset.testMode || 'off';
    var triggerSelectors = [];

    if (boolAttr(block.dataset.textPopupStrong)) triggerSelectors.push('strong');
    if (boolAttr(block.dataset.textPopupEm)) triggerSelectors.push('em');
    if (boolAttr(block.dataset.textPopupUnderline)) {
      triggerSelectors.push('u');
      triggerSelectors.push('span[style*="underline"]');
    }

    if (!triggerSelectors.length) return;

    function openModal() {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (testMode !== 'off') return;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function handleEscape(event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    }

    if (testMode === 'animate') {
      var speed = parseInt(modal.dataset.animationSpeed) || 250;
      document.body.style.overflow = 'hidden';
      (function animateLoop() {
        modal.classList.add('is-open');
        setTimeout(function () {
          modal.classList.remove('is-open');
          setTimeout(animateLoop, speed + 400);
        }, 2000);
      })();
    }

    triggerSelectors.forEach(function (selector) {
      toArray(contentArea.querySelectorAll(selector)).forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          openModal();
        });
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal && closeOnOutsideClick) {
        closeModal();
      }
    });

    toArray(modal.querySelectorAll('[data-text-popup-close]')).forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', handleEscape);
  }

  function initBlock(block) {
    if (!block || block.dataset.textBlockInitialized === 'true') return;
    block.dataset.textBlockInitialized = 'true';

    var blockId = block.dataset.textBlockId;
    if (!blockId) return;

    if (boolAttr(block.dataset.textPopupEnabled)) {
      initPopup(block, blockId);
    }
    initLinkActions(block);
    if (boolAttr(block.dataset.textCountdownEnabled)) {
      initCountdown(block);
    }
    if (boolAttr(block.dataset.textLocationEnabled)) {
      initLocation(block);
    }
    if (boolAttr(block.dataset.textDateEnabled)) {
      initDates(block);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-text-block]')) {
      initBlock(scope);
    }

    toArray(scope.querySelectorAll('[data-text-block]')).forEach(initBlock);
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });
})();
